<template>
<section class="person-grid px-4 py-4">
    <div class="max-w-4xl mx-auto">
        <SmoothLoader v-if="headline" v-html="headline" tag="h2" class="font-headline text-3xl my-4 text-white font-medium uppercase tracking-wider leading-tight text-center"></SmoothLoader>
        <SmoothLoader class="grid">
            <Link v-for="(person, i) in people" :id="person.slug" class="person-wrapper flex flex-wrap justify-center relative" :href="person.href">
                
                <div class="headshot w-full flex justify-center overflow-hidden" :class="{'bg-primary-700 bg-opacity-20': !person.photo}">
                    <img v-if="person.photo" :src="person.photo.src" loading="lazy" class="">
                </div>

                <div class="p-4 text-center w-full">
                    <span class="name block font-headline uppercase font-medium text-gray-400 text-lg tracking-wider transition-colors" v-html="person.name"></span>
                </div>

            </Link>
        </SmoothLoader>
    </div>
</section>

</template>

<script>

const $ = window.jQuery;
export default {
    props: ['data'],
    setup(props) {
        return {
            ...props.data
        }
    }
}
</script>